import { useQuery } from '@apollo/client';

import { getTableauToken } from '@/api';
import { getUserId, resolveGqlErrors } from '@/helpers';

const tenMinutes = 60 * 10 * 1000;

type UseTableauToken = () => {
  loading: boolean;
  token: string;
  uuid: string;
  error: string;
};

const useTableauToken: UseTableauToken = () => {
  const { loading, data, error } = useQuery(getTableauToken, {
    variables: { userId: getUserId()! },
    pollInterval: tenMinutes,
  });

  const token = data?.getTableauToken?.token || '';
  const uuid = data?.getUser?.user?.uuid || '';

  return {
    loading,
    token,
    uuid,
    error: resolveGqlErrors(error || data?.getTableauToken?.error),
  };
};

export default useTableauToken;
